<template>
  <v-container fluid grid-list-lg class="pa-5">
    <v-layout align-center justify-center>
      <v-flex md9 class="headline">
        Plantillas
      </v-flex>
      <v-flex md3>
        <v-btn class="k-orange-linear white--text" block large @click="show = !show">Agregar plantilla</v-btn>
      </v-flex>
    </v-layout>
    <v-layout row wrap>
      <v-flex md8>
        <v-text-field
          v-model="search"
          label="Buscar..."
          color="black"
          solo>
        </v-text-field>
      </v-flex>
      <v-flex md4>
        <v-select
          v-model="filters.category"
          :items="categoriesSaved"
          item-value="value"
          item-text="category"
          class="white--text"
          label="Categorias.."
          color="grey"
          autocomplete
          solo>
        </v-select>
      </v-flex>
    </v-layout>
    <v-layout row wrap mt-2>
      <v-flex xs12>
        <data-table
          ref="campaignTemplateList"
          url="templates"
          :search="search"
          :filters="filters"
          :refresh="refresh"
          @items-reload="itemsLoaded">
          <template slot="content" v-for="(item, i) in templateList">
            <v-list-tile
              :key="`templateListItem-${item.id}`"
              avatar>
              <v-list-tile-avatar>
                <v-icon class="f2-5em k-orange-linear-text">fas fa-newspaper</v-icon>
              </v-list-tile-avatar>
              <v-list-tile-content>
                <v-list-tile-title>
                  <strong>
                    {{ item.name }}
                  </strong>
                </v-list-tile-title>
                <v-list-tile-sub-title>
                  {{item.template_code}} ({{item.category}})
                </v-list-tile-sub-title>
              </v-list-tile-content>
              <v-spacer></v-spacer>
              <v-flex class="text-xs-right">
                <v-btn icon class="k-orange-linear-underline" outline @click="editItem(item, 2)">
                  <v-icon small class="k-orange-linear-text">fas fa-comments</v-icon>
                </v-btn>
                <v-btn icon class="k-orange-linear-underline" outline @click="editItem(item, 1)">
                  <v-icon small class="k-orange-linear-text">fas fa-envelope</v-icon>
                </v-btn>
                <!-- <v-btn icon class="k-orange-linear-underline" outline @click="editItem(item, 3)">
                  <v-icon small class="k-orange-linear-text">fas fa-phone fa-rotate-90</v-icon>
                </v-btn> -->
                <v-menu offset-y>
                  <v-btn icon slot="activator" class="k-orange-linear-underline" outline>
                    <v-icon small class="k-orange-linear-text">fas fa-stream</v-icon>
                  </v-btn>
                  <v-list>
                    <v-subheader>PRUEBAS</v-subheader>
                    <v-divider></v-divider>
                    <v-list-tile v-if="item.sms" @click="doTest(item, 2)">
                      <v-list-tile-title class="k-grey-text">SMS</v-list-tile-title>
                    </v-list-tile>
                    <v-list-tile v-if="item.text" @click="doTest(item, 1)">
                      <v-list-tile-title class="k-grey-text">EMAIL</v-list-tile-title>
                    </v-list-tile>
                    <!-- <v-list-tile v-if="item.ivr" @click="doTest(item, 3)">
                      <v-list-tile-title class="k-grey-text">IVR</v-list-tile-title>
                    </v-list-tile> -->
                  </v-list>
                </v-menu>
              </v-flex>
            </v-list-tile>
            <v-divider
              v-if="i !== templateList.length - 1"
              :key="`divider${i}`"/>
          </template>
        </data-table>
      </v-flex>
    </v-layout>
    <create-template-dialog 
      :show="show"
      :categories-saved="categoriesSaved"
      @saved="refresh = !refresh"
      @close="show = false">
    </create-template-dialog>
    <template-dialog
      :show="templateDialog"
      :channel="channel"
      :template="selected"
      :is-new-workflow="false"
      :show-unused-fields="false"
      :append-vars="templateAppendVars"
      @save="saveTemplate"
      @close="closeTemplateDialog" />
    <test-template-dialog
      :show="testTemplateDialog"
      :template-id="templateId"
      :channel="channelId"
      @close="closeTestDialog" />
  </v-container>
</template>
<script>
import ChannelMixin from '@/mixins/channels';
import DataTable from '@/components/global/DataTable2';
import TemplateDialog from '@/components/Templates/Index';
import TestTemplateDialog from '@/components/Templates/TestDialog';
import CreateTemplateDialog from '@/components/templateV2/CreateTemplateDialog';

export default {
  mounted() {
    this.getCategories();
  },
  mixins: [
    ChannelMixin,
  ],
  components: {
    DataTable,
    TemplateDialog,
    TestTemplateDialog,
    CreateTemplateDialog,
  },
  data() {
    const templateAppendVars = [];
    for (let i = 1; i <= 15; i += 1) {
      templateAppendVars.push(`var_${i}`);
    }
    return {
      show: false,
      search: '',
      refresh: false,
      filters: {
        type: 'campaign',
        category: null,
      },
      channelId: 0,
      selected: {},
      templateList: [],
      categoriesSaved: [],
      templateDialog: false,
      testTemplateDialog: false,
      templateAppendVars,
      templateId: 0,
    };
  },
  computed: {
    channel() {
      if (!this.channelId) {
        return '';
      }
      return this.getChannelField('id', this.channelId, 'channel') || '';
    },
  },
  methods: {
    getCategories() {
      this.axios.get('/templates/categories').then(({ data }) => {
        if (data.length > 0) {
          /* eslint-disable */
          this.categoriesSaved = data.map((item) => {
            let o = {
              category: '',
              value: '',
            };
            o.category = `${item.category.substr(0,1).toUpperCase()}${item.category.substr(1, 50).toLowerCase()}`;
            o.value = item.category;
            return o;
          });
          /* eslint-enable */
          this.categoriesSaved.unshift({
            category: 'Categorias',
            value: '',
          });
          /* eslint-disable */
          let actualObj = this.categoriesSaved.find(item => item.value === this.filters.category);
          actualObj ? '' : this.filters.category = '';
          /* eslint-enable */
        }
      });
    },
    itemsLoaded($event) {
      this.templateList = $event;
    },
    editItem(item, channel) {
      this.channelId = channel;
      let text = '';
      switch (channel) {
        case 1:
          text = item.text || '';
          break;
        case 2:
          text = item.sms || '';
          break;
        // case 3:
        //   text = item.ivr || '';
        //   break;
        default:
          text = '';
          break;
      }
      this.selected = {
        id: item.id,
        ...channel === 1 && {
          company_email_id: item.company_email_id,
          subject: item.subject,
        },
        sms_enable_short_url: item.sms_enable_short_url,
        text,
      };
      this.templateDialog = true;
    },
    doTest(item, channel) {
      this.channelId = channel;
      this.templateId = item.id;
      this.testTemplateDialog = true;
    },
    saveTemplate($event) {
      const index = this.templateList.findIndex(item => item.id === this.selected.id);
      if (index >= 0) {
        const template = this.templateList[index];
        if (this.channel === 'email') {
          template.company_email_id = $event.company_email_id;
          template.subject = $event.subject;
          template.text = $event.text;
        } else {
          template[this.channel] = $event.text;
        }
        const form = {
          channel: this.channel,
          company_email_id: template.company_email_id,
          template_code: template.template_code,
          name: template.name,
          from: template.from,
          from_name: template.from_name,
          reply: template.reply,
          subject: template.subject,
          voice: template.voice,
          text: template.text,
          sms: template.sms,
          // ivr: template.ivr,
          human: template.human,
          visit: template.visit,
          type: template.type,
          category: template.category,
          status: template.status,
          sms_enable_short_url: $event.sms_enable_short_url,
        };
        this.axios.patch(`templates/${this.selected.id}`, {
          ...form,
        }).then(() => {
          this.templateDialog = false;
          this.channelId = 0;
          this.selected = {};
        });
      }
    },
    closeTemplateDialog() {
      this.templateDialog = false;
      this.selected = {};
    },
    closeTestDialog() {
      this.channelId = 0;
      this.templateId = 0;
      this.testTemplateDialog = false;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/templateV2/Index.vue